/**
 * "같은 검색인가, 새 검색인가"를 나타내는 안정적인 키.
 *
 * 지도는 *새 검색*일 때만 움직여야 한다. 그런데 검색 결과 URL에는 검색 자체와
 * 무관한 파라미터가 끊임없이 덧붙는다 — pan/zoom을 복원용으로 기록하는
 * view 동기화(zoom·clat·clng, replaceState)와 카테고리 필터(pushState)가 대표적이다.
 * 이것들까지 키에 넣으면 사용자가 지도를 조금 움직이거나 필터를 켤 때마다
 * "새 검색"으로 오인해 지도를 강제로 되돌려 버린다.
 *
 * bounds(ne_lat/ne_lng/sw_lat/sw_lng)와 t는 일부러 뺀다 — 그 조합은 기존
 * fit-on-t 효과가 이미 담당하는 경로라서, 여기서 또 반응하면 이동이 두 번 일어난다.
 *
 * 그래서 키는 pathname·scope·q 세 가지로만 만든다.
 */
export function searchIdentityFromUrl(
  pathname: string,
  params: URLSearchParams | { get(key: string): string | null },
): string {
  const scope = params.get("scope") ?? "";
  const q = params.get("q") ?? "";
  return `${pathname}|${scope}|${q}`;
}
